import React, { useContext, useState } from "react";
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBContainer
} from "mdbreact";
import { Link } from 'react-router-dom';

import HeaderLoggedIn from "./HeaderLoggedIn";
import HeaderLoggedOut from './HeaderLoggedOut'
import StateContext from '../../StateContext'
import DispatchContext from "../../DispatchContext";

function NavbarPage(props) {

    const [isOpen, setIsOpen] = useState(false)
    const appState = useContext(StateContext)
    const appDispatch = useContext(DispatchContext);
    

    const headerContent = appState.loggedIn ? <HeaderLoggedIn setIsOpen={setIsOpen} /> : <HeaderLoggedOut />

    const toggleCollapse = () => {
        if (isOpen) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }


  return (
    
      <MDBNavbar color="blue" dark expand="md">
          <MDBContainer>
            <MDBNavbarBrand>     
                <Link to="/">
                    <img src="https://camillahardilla.com/wp-content/uploads/2020/07/my-recipes-logo.png" className="img-fluid rounded-circle" style={{maxWidth: "35px"}} alt="Site logo"/>
                </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler onClick={toggleCollapse} />
            <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
                <MDBNavbarNav left>
                    <MDBNavItem>
                        <MDBNavLink to="/">Min side</MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/lanekalkulator">Lånekalkulator</MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/boligpriskalkulator">Boligpriskalkulator</MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/currencies">Valutakalkulator</MDBNavLink>
                    </MDBNavItem>
                </MDBNavbarNav>

            {!props.staticEmpty ? headerContent : ""}

            </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    );
  }


export default NavbarPage;